module.exports = __webpack_public_path__ + "img/media-news2.8cce8f7d.png";